import { SnowflakeIconUrl } from "@p0security/shared/integrations/constants";
import { SnowflakeComponents } from "@p0security/shared/integrations/resources/snowflake/components";
import { Typography } from "antd";
import { useCallback } from "react";

import { useOktaGroups } from "../../../hooks/useOktaGroups";
import { useAuthFetch } from "../../Login/hook";
import { Install, InstallProps } from "../Install/Install";
import { snowflakeInstaller } from "./install/install";

const SnowflakePreamble = (
  <>
    <Typography.Paragraph>
      Enable IAM management for Snowflake with just-in-time access provisioning
      and support for SCIM user provisioning via Okta.
    </Typography.Paragraph>
    <Typography.Text strong>Prerequisites:</Typography.Text>
    <ul className="preamble-list">
      <li>
        <code>ACCOUNTADMIN</code> role privileges in Snowflake
      </li>
      <li>Snowflake account identifier</li>
    </ul>
  </>
);

export const Snowflake = (
  props: Pick<
    InstallProps<typeof SnowflakeComponents>,
    "cardOverride" | "onInstall"
  >
) => {
  const itemKind = useCallback(() => "account", []);
  const authFetch = useAuthFetch();
  // Only support Okta SCIM for now
  // using oktaAuthFetch to separate the error state from the main authFetch
  // failure in installation and configuration are different
  const { groups } = useOktaGroups(authFetch);
  return (
    <Install<typeof SnowflakeComponents>
      components={SnowflakeComponents}
      installer={snowflakeInstaller(groups)}
      integration="snowflake"
      itemKind={itemKind}
      logo={SnowflakeIconUrl}
      preamble={SnowflakePreamble}
      title={"Snowflake"}
      {...props}
    />
  );
};
